query sectionsCube($scenarioId: ID!, $filter: PaginationInput!, $originId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    sections(filter: $filter) {
      items {
        id
        code
        vacancies
        bundle {
          term {
            code
          }
        }
        course {
          id
          name
          code
          curriculum {
            id
            code
            program {
              campus {
                id
                code
              }
            }
          }
        }
        schedule {
          resourceAssigment {
            schedule
          }
        }
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
        __typename
      }
      __typename
    }
    __typename
  }
}
